import styled from 'styled-components';
import { accent, primary, white, symbol } from '~/components/mixins/color';

export const Container = styled.div`
  height: 100%;
  width: 60px;
  background: ${primary.hex()};
  color: #fff;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  padding: 10px 0 0;
  box-shadow: 2px -2px 2px -2px #ccc;
`;

export const Sidebar = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;

  img {
    margin-bottom: 15px;
    height: 48px;
  }

  nav {
    display: flex;
    align-items: center;
    overflow-y: scroll;
    height: calc(100vh - 147px);

    ::-webkit-scrollbar {
      display: none;
    }

    > ul {
      height: 100%;
    }

    a {
      display: flex;
      align-items: center;
      justify-content: center;
      color: ${symbol.string()};
      border-radius: 50%;
      margin-bottom: 2px;

      &.active {
        color: ${white.hex()};
        background: ${accent.hex()};
      }
      &:hover {
        color: ${white.hex()};
        background: ${symbol.hex()};
      }
    }
    li {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 36px;
      height: 36px;
      padding: 5px;
      cursor: pointer;
    }
  }
`;

export const Profile = styled.div`
  display: flex;
  align-items: center;
  margin: 3px;
  padding: 5px;

  @media (min-width: 1025px) {
    display: none;
  }

  img {
    cursor: pointer;
    height: 22px;
    width: 22px;
    border-radius: 3px;
  }
`;

export const Aside = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  li {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 36px;
    height: 36px;
    color: ${symbol.hex()};
    cursor: pointer;
    border-radius: 50%;

    &:hover {
      color: ${white.hex()};
      background: ${symbol.hex()};
    }
  }
`;
